module.exports = __webpack_public_path__ + "static/lemonchickonesie-06e363edcff9a78d10bd2690bdd5d460.jpeg";